import { connect } from 'react-redux';
import StepFour from 'views/register/stepFour/StepFour';
import { getLoginRequest } from 'store/actions/auth.actions';

const mapDispatchToProps = { loginRequest: getLoginRequest };

export default connect(null, mapDispatchToProps)(StepFour);
